<template>
  <div>
    <!-- dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="importDialog"
      :title="dialogTitle"
      width="75%"
      @close="clearImportData"
    >
      <el-row class="import-table">
        <ImportData
          ref="import"
          :showBtn="false"
          :excelName="excelName"
          :tableData="importTable"
          :uploadUrl="uploadUrl"
          :downloadUrl="downloadUrl"
          @beginUpload="beginUpload"
          @returnData="returnData"
        >
          <el-popover
            v-if="permissionData.length > 1"
            placement="bottom"
            trigger="click"
          >
            <span v-for="(item, index) in permissionOriginData" :key="index">
              <el-link
                type="primary"
                v-if="permissionData.includes(item.href)"
                @click="downloadFile"
                >{{ item.name }}</el-link
              >
            </span>
            <el-button type="primary" slot="reference">下载模板2</el-button>
          </el-popover>
        </ImportData>
      </el-row>
      <wxe-table
        ref="wxeTable"
        :title="title"
        :importRowErrMsg="'errorMsg'"
        :tableData="importTable"
        :tableHead="tableColumns"
        :loading="loading"
        @wxe-table-select="importTableChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="addOrderDetail"
          :disabled="importSelection.length === 0"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImportData from '@/components/ImportData';
import WxeTable from '@/components/ImportData/WxeTable';
import download from '@/utils/download';
import { pageNameArr } from '@/utils/pageInfo';

export default {
  components: { ImportData, WxeTable },
  data() {
    return {
      msg: '',
      showTable: false,
      loading: false,
      importDialog: false,
      uploadUrl:
        process.env.VUE_APP_OMS_PUBLISH_URL +
        '/oms-quota-service/api/salesPlan/report/importCommodity',
      downloadUrl:
        process.env.VUE_APP_OMS_DOWNLOAD_URL + '配额提报导入模板.xlsx',
      importTable: [],
      tableColumns: [
        { prop: 'errorMsg', label: '提示' },
        { prop: 'brandName', label: '品牌', width: 120 },
        { prop: 'commodityBarcode', label: '商品条形码', width: 150 },
        { prop: 'commodityArtNo', label: '商品编码', width: 150 },
        { prop: 'isNewName', label: '是否新品', width: 120 },
        { prop: 'commodityTypeName', label: '商品品类', width: 150 },
        { prop: 'commodityName', label: '商品名称' },
        { prop: 'commodityPrice', label: '商城价', width: 120 },
        { prop: 'spec', label: '规格', width: 150 },
        { prop: 'reportNum', label: '提报数量', width: 120 },
        { prop: 'earlyMonthNum', label: '上旬数量', width: 120 },
        { prop: 'lateMonthNum', label: '下旬数量', width: 120 },
        { prop: 'lastThirdMonthNum', label: '近3月执行总量', width: 120 },
      ],
      excelName: '配额提报导入模板.xlsx',
      title: 'daoru',
      dialogTitle: '批量导入文件上传',
      importSelection: [],
      permissionOriginData: [
        { name: '包材样品模板', href: 'sample-manage/publish-package-sample' },
        { name: '发布单个ODM样品', href: 'sample-manage/publish-ODM-sample' },
        {
          name: '发布单个膜布样品',
          href: 'sample-manage/publish-membrane-sample',
        },
        {
          name: '发布单个原料样品',
          href: 'sample-manage/publish-material-sample',
        },
      ],
      permissionData: [],
      hasMorePermission: false,
    };
  },
  props: {
    importParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    importTable(val) {
      if (val.length === 0) this.$refs.import.fileList = [];
    },
  },
  mounted() {
    const { category } = this.$store.getters.userSupplier;
    this.category = category;
    // 判断是否具有多个权限, 目前外部供应商只有一种权限
    this.permissionOriginData = pageNameArr;
    this.permissionData = this.category.reduce((prev, cur) => {
      if (this.permissionOriginData.findIndex(item => item.type === cur) > -1) {
        prev.push(cur);
      }
      return prev;
    }, []);
  },
  methods: {
    beginUpload() {
      this.loading = true;
    },
    // 返回预览导入数据
    returnData(val) {
      this.loading = true;
      this.importTable = val.map(item => {
        item.isNewName = item.isNew == '10' ? '是' : '否';
        return item;
      });
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 添加导入明细
    addOrderDetail() {
      // 判断是否有不符合导入要求的数据
      if (this.importTable.length === 0) {
        this.$message.error('导入数据为空，请重新选择文件');
        this.$refs.import.loading = false;
        return;
      }
      if (this.importSelection.some(item => item.errorMsg)) {
        this.$message.error('所选数据包含错误数据，请重新选择');
        this.$refs.import.loading = false;
        return;
      }
      this.$emit('add-order-detail', this.importSelection);
      this.importDialog = false;
    },
    // 删除导入列表所选数据
    deleteImportData() {
      this.$confirm('确定删除选中数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.importTable = this.importTable.filter(
          item => !this.importSelection.includes(item),
        );
        this.importSelection = [];
        this.$refs.wxeTable.removeSelecteds();
      });
    },
    clearImportData() {
      this.importTable = [];
      this.importSelection = [];
      this.$refs.import.remove();
    },
    importTableChange(val) {
      this.importSelection = val;
    },
    // 下载模板文件
    downloadFile({ fileUrl, fileName }) {
      download(fileUrl, fileName);
    },
  },
};
</script>

<style lang="less" scoped>
.import-table {
  display: flex;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.el-link {
  margin: 0 10px;
}
</style>
